import { RootState } from '../reducers'

export const weatherDaysSelector = (state: RootState) => state.weather
